import { useEffect, useState } from 'react';

/**
 * Read translations from window.languageContext. Mirrors the pattern used
 * across ProductPerformance / RecentSales / etc. Returns:
 *   - language: the raw key/value bag (or null while loading),
 *   - t(): a small helper that does fallback to a default English string.
 */
export function useLanguage() {
  const [language, setLanguage] = useState<any>(null);

  useEffect(() => {
    // window.languageContext is populated by the host shell (dev-core-web)
    // asynchronously, after it fetches the locale JSON. Read it on mount for
    // the already-loaded case and re-read on the "languageLoaded" DOM event
    // the host's Header dispatches on both load paths, so a cold load of
    // /al/pos-reports does not stay English until the next navigation.
    const refresh = () => {
      if (window.languageContext) {
        setLanguage(window.languageContext.language);
      }
    };
    refresh();
    document.addEventListener('languageLoaded', refresh);
    return () => document.removeEventListener('languageLoaded', refresh);
  }, []);

  const t = (key: string, fallback?: string): string => {
    if (language && typeof language[key] === 'string' && language[key] !== '') {
      return language[key];
    }
    return fallback ?? key;
  };

  return { language, t };
}
